import {
  checkFormat,
  maskOnlyNumbers
} from 'views/CRMGasOrder/GasOrder/list/utils';
import SimpleHeader from '../../../../components/Headers/SimpleHeader';
import ReactButton from '../../../../components/Buttons/ReactButton';
import FlexSelect from '../../../../components/Inputs/FlexSelect';
import { useGetFamily } from '../hooks/useGetFamily';
import { useGetUnity } from '../hooks/useGetUnity';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ReactLoader from '../../../../components/Loader';
import { useForm, Controller } from 'react-hook-form';
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import ProductService from '../service';
import {
  Container,
  Row,
  Card,
  Form,
  Col,
  Input,
  CardHeader,
  CardBody,
  Label
} from 'reactstrap';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '@material-ui/core';

const CreateProduct = (props) => {
  const [control1, setControl1] = useState(true);
  const [control2, setControl2] = useState(true);
  const [isActive, setIsActive] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [productData, setProductData] = useState({});
  const { handleSubmit, control, setValue } = useForm();

  const { families } = useGetFamily();
  const { unities } = useGetUnity();

  const { id } = props.match.params;

  useEffect(() => {
    if (id) {
      setIsUpdate(true);
      getSingleProduct(id);
    }
  }, [id]);

  async function getSingleProduct(id) {
    setIsLoading(true);

    await ProductService.get(`${id}`)
      .then((res) => {
        console.log(res.data.data);
        setProductData(res.data.data);

        setIsLoading(false);
      })
      .catch(() => {});
  }

  const onSubmit = (obj) => {
    let objectToSend = { ...obj, ativo: !isActive };
    console.log(objectToSend);

    if (isUpdate) {
      ProductService.put(`${id}`, objectToSend)
        .then(() => {
          history.push('/admin/gasOrderProducts');
          toast.success('Produto alterado com sucesso!', {
            autoClose: 3000,
            closeOnClick: true
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      ProductService.post(objectToSend)
        .then(() => {
          history.push('/admin/gasOrderProducts');
          toast.success('Produto cadastrado com sucesso!', {
            autoClose: 3000,
            closeOnClick: true
          });
        })
        .catch((err) => {
          toast.error(`${err.response.data.message}`, {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    }
  };

  const history = useHistory();

  const cancelAction = () => {
    history.push('/admin/gasOrderProducts/');
  };

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        returnPath="/admin/gasOrderProducts"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3>{isUpdate ? 'Editar Produto' : 'Cadastro do Produto'}</h3>
                </CardHeader>

                <CardBody>
                  {isLoading ? (
                    <Row className="justify-content-md-center">
                      <ReactLoader />
                    </Row>
                  ) : (
                    <Form onSubmit={handleSubmit(onSubmit)}>
                      {/* Informações de produto */}
                      <Accordion
                        expanded={control1}
                        onChange={() => setControl1(!control1)}
                        className="accodion"
                        style={{ boxShadow: 'none', borderBottom: 'none' }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          style={{ borderBottom: '1px solid #dcdcdc' }}
                        >
                          <strong>Informações do Produto</strong>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            flexDirection: 'column'
                          }}
                        >
                          <Row className="mb-3">
                            <Col md="6">
                              <label className="form-control-label">
                                Nome do Produto{' '}
                              </label>
                              <Controller
                                as={<Input />}
                                defaultValue={isUpdate ? productData.nome : ''}
                                control={control}
                                name="nome"
                              />
                            </Col>
                            <Col md="6">
                              <label className="form-control-label">
                                Código do Produto
                              </label>
                              <Controller
                                as={<Input />}
                                control={control}
                                name="codigo"
                                defaultValue={
                                  isUpdate ? productData.codigo : ''
                                }
                              />
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col md="6">
                              <label className="form-control-label">
                                Família de produtos
                              </label>
                              <Controller
                                render={(props) => (
                                  <FlexSelect
                                    dataOptions={families}
                                    isMulti={false}
                                    value={props.value}
                                    valueController={setValue}
                                    closeMenuOnSelect={true}
                                    isClearable={true}
                                    fieldName="familiaId"
                                    labelName="nome"
                                    valueName="id"
                                  />
                                )}
                                control={control}
                                name="familiaId"
                                defaultValue={
                                  isUpdate ? productData.familiaId : ''
                                }
                              />
                            </Col>
                            <Col md="6">
                              <label className="form-control-label">
                                Unidade de medida do produto
                              </label>
                              <Controller
                                render={(props) => (
                                  <FlexSelect
                                    dataOptions={unities}
                                    isMulti={false}
                                    value={props.value}
                                    {...console.log(props.value)}
                                    valueController={setValue}
                                    closeMenuOnSelect={true}
                                    fieldName="unidadeMedidaId"
                                    labelName="nome"
                                    valueName="id"
                                  />
                                )}
                                control={control}
                                name="unidadeMedidaId"
                                defaultValue={
                                  isUpdate ? productData.unidadeMedidaId : ''
                                }
                              />
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col md="6">
                              <label className="form-control-label">
                                Descrição
                              </label>
                              <Controller
                                as={<Input type="textarea" rows="6" />}
                                defaultValue={
                                  isUpdate ? productData.descricao : ''
                                }
                                control={control}
                                name="descricao"
                              />
                            </Col>
                            <Col md="6">
                              <label className="form-control-label">
                                Valor do Produto{' '}
                              </label>
                              <Controller
                                render={({ onChange }) => (
                                  <Input
                                    defaultValue={
                                      isUpdate ? productData.preco : ''
                                    }
                                    onBlur={() => {
                                      document.getElementById(
                                        'valueInput'
                                      ).value = checkFormat(
                                        document.getElementById('valueInput')
                                          .value
                                      );
                                    }}
                                    id="valueInput"
                                    onChange={(event) => {
                                      let value = maskOnlyNumbers(
                                        event.target.value
                                      );
                                      event.target.value = value.exibValue;
                                      onChange(value.formatedValue);
                                    }}
                                  ></Input>
                                )}
                                onChange={(val) => {
                                  return val;
                                }}
                                control={control}
                                name="preco"
                                defaultValue={isUpdate ? productData.preco : ''}
                              />

                              <Col md="6">
                                <Label className="form-control-label" check>
                                  <Input
                                    type="checkbox"
                                    checked={!isActive}
                                    onChange={() => {
                                      setIsActive(!isActive);
                                      console.log(isActive);
                                    }}
                                  />
                                  <span>Ativo</span>
                                </Label>
                              </Col>
                            </Col>
                          </Row>
                        </AccordionDetails>
                      </Accordion>

                      {/* Informações de produto */}
                      {/* Informações do sistema */}
                      <Accordion
                        expanded={control2}
                        onChange={() => setControl2(!control2)}
                        className="accodion"
                        style={{
                          boxShadow: 'none',
                          borderBottom: 'none',
                          paddingBottom: '0.5rem'
                        }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          style={{ borderBottom: '1px solid #dcdcdc' }}
                        >
                          <strong>Informações do sistema</strong>
                        </AccordionSummary>
                        <AccordionDetails style={{ flexDirection: 'column' }}>
                          <Row className="mb-3">
                            <Col md="6">
                              <label className="form-control-label">
                                Criado por{' '}
                              </label>
                              <Controller
                                as={<Input disabled />}
                                control={control}
                                name="criadoPor"
                                defaultValue={
                                  isUpdate
                                    ? productData.auditoria !== null
                                      ? productData.auditoria.criadoPor
                                      : ''
                                    : `${localStorage.getItem('login')}`
                                }
                              />
                            </Col>
                            <Col md="6">
                              {/* Checkar input cnpj */}
                              <label className="form-control-label">
                                Alterado por{' '}
                              </label>

                              <Input
                                disabled
                                defaultValue={
                                  isUpdate
                                    ? productData.auditoria !== null
                                      ? productData.auditoria.atualizadoPor
                                      : ''
                                    : ''
                                }
                              />
                            </Col>
                          </Row>
                        </AccordionDetails>
                      </Accordion>

                      {/* Informa1ções do sistema */}

                      <ReactButton btnColor="confirmation" type="submit">
                        Salvar
                      </ReactButton>
                      <ReactButton
                        btnColor="cancelation"
                        onClick={() => {
                          cancelAction();
                        }}
                      >
                        Cancelar
                      </ReactButton>
                    </Form>
                  )}
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default CreateProduct;
